import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviFacturesService, { FacturesParams } from '../../../services/SuiviFacturesService';
import { SUIVI_FACTURES_PAYEES } from './mutation-types';
import { SuiviFacturesPayees, SuiviFacturesPayeesActionTypes } from './action-types';
import { SuiviFacturesPayeesState } from './state';
import { SuiviFacture } from '@/models/SuiviFacture';

export const actions: ActionTree<SuiviFacturesPayeesState, RootState> = {
    async [SuiviFacturesPayees.GET_SUIVI_FACTURES_PAYEES](
        { commit }: SuiviFacturesPayeesActionTypes,
        payload: FacturesParams
    ) {
        commit(SUIVI_FACTURES_PAYEES.SET_PAGE_PAYEES, payload.page);
        commit(SUIVI_FACTURES_PAYEES.SET_ERROR_PAYEES, undefined);
        commit(SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES, true);
        try {
            const response = await SuiviFacturesService.getSuiviFacturesPayees(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(SUIVI_FACTURES_PAYEES.SET_ITEMS_PAYEES, response.data.content);
                    commit(SUIVI_FACTURES_PAYEES.SET_SCROLL, 0);
                    commit(SUIVI_FACTURES_PAYEES.SET_NB_OF_PAGES_PAYEES, response.data.totalPages);
                    commit(SUIVI_FACTURES_PAYEES.SET_COUNT_PAYEES, response.data.totalElements);
                } else {
                    commit(SUIVI_FACTURES_PAYEES.ADD_ITEMS, response.data.content);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES, false);
        } catch (error) {
            commit(SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES, false);
            commit(SUIVI_FACTURES_PAYEES.SET_ERROR_PAYEES, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviFacturesPayees.GET_FACTURES_PAYEES_PDF](
        { commit }: SuiviFacturesPayeesActionTypes,
        factureToDownload: SuiviFacture
    ) {
        try {
            const response = await SuiviFacturesService.getFacturePdf(factureToDownload.numeroFacture, factureToDownload.societeId);
            if (response.status === 200 && response.data !== undefined) {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = `${factureToDownload.numeroFacture}.pdf`;
                link.click();
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES, false);
        } catch (error) {
            commit(SUIVI_FACTURES_PAYEES.SET_IS_LOADING_PAYEES, false);
            commit(SUIVI_FACTURES_PAYEES.SET_ERROR_PAYEES, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
